// extracted by mini-css-extract-plugin
export default {"container":"LessonViewer_container__0e+p+","center-col":"LessonViewer_center-col__iH9CI"};